module.exports = __webpack_public_path__ + "static/img/6671_phase_function_Paper_Points.bee9a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6671_phase_function_Paper_Points.png
// module id = ZTwf
// module chunks = 0